import { ApiProperty } from "@nestjs/swagger";

export class AsnIdReq{
    @ApiProperty()
    asnId:number
}